import { useTranslation } from "react-i18next";
import _ from "underscore";
import { useSelector } from "react-redux";

import { ViedocButtonElement } from "../../../../secure/elements/ViedocReactElements";

import * as UtilsHelper from "../../../../../utils/utilsHelper";
import { Fragment } from "react";
import APP_CONST from "../../../shared/constants";

const FileDownload = ({
  downloadFileHandler,
  category,
  latestArchiveInformation,
}) => {
  const { fullDateTimePattern, dateLocale, isFileDownloading } = useSelector(
    (store) => store.template
  );

  const { t } = useTranslation();

  const renderDownloadButton = (archiveInfo) => {
    return (
      <div className="archive-generate-button">
        <ViedocButtonElement
          variant="info"
          onClick={() => downloadFileHandler(archiveInfo)}
          title={!isFileDownloading ? t("TMF.TEXT_DOWNLOAD") : ""}
        >
          {isFileDownloading ? <viedoc-spinner /> : t("TMF.TEXT_DOWNLOAD")}
        </ViedocButtonElement>
      </div>
    );
  };

  const renderDocumentDetails = (archiveInfo) => {
    const archiveInfoDetails = [
      archiveInfo.tmfside,
      archiveInfo.trial,
      archiveInfo.countries,
      archiveInfo.sites,
      archiveInfo.milestone,
      archiveInfo?.milestonegroup,
    ];
    const displayarchiveInfo = archiveInfoDetails?.filter((item) => item);
    return (
      <p className="lh1_5">
        {displayarchiveInfo?.map((displayList, index) => (
          <Fragment key={index}>{(index ? ", " : "") + displayList}</Fragment>
        ))}
      </p>
    );
  };

  const renderFileTypeCard = (archiveInfo) => {
    return (
      <div
        style={{ background: category === APP_CONST.TEXT_ARCHIVE ? "grey" : "" }}
        className="archive-generate-file"
      >
        {UtilsHelper.getFileExtension(archiveInfo.filename).toLocaleUpperCase()}
      </div>
    );
  };

  const renderDateTime = (archiveInfo) => {
    return fullDateTimePattern
      ? UtilsHelper.getFormattedDateTime(
          fullDateTimePattern,
          archiveInfo.createdon,
          dateLocale
        )
      : UtilsHelper.momentLocalConversion(archiveInfo.createdon, true);
  };

  const renderFileDetails = (archiveInfo) => {
    return (
      <div className="archive-generate-content">
        <h4 className="dark-grey lh1_5" title={archiveInfo.filename}>{archiveInfo.filename}</h4>
        <p className="lh1_5">
          <span className="fw-700 dark-grey">
            {UtilsHelper.getFileSize(archiveInfo.filesize)}
          </span>
          , {t("TMF.TEXT_GENERATED")}{" "}
          <span className="fw-700 dark-grey">
            {renderDateTime(archiveInfo)}
          </span>{" "}
          {t("TMF.TEXT_BY")} {archiveInfo.createdby}
        </p>
        <div>
          <p>
            {category === APP_CONST.TEXT_ARCHIVE
              ? t("ARCHIVE.TEXT_ETMFEMSRESPOSITORY")
              : t("ARCHIVE.TEXT_AUDITTRAILREPORT")}
          </p>
        </div>
        {renderDocumentDetails(archiveInfo)}
      </div>
    );
  };

  return (
    <div className="archive-generate-download">
      {latestArchiveInformation.map(
        (archiveInfo) =>
          !_.isEmpty(archiveInfo) &&
          archiveInfo.category === category && (
            <div key={archiveInfo.category} className="archive-box">
              {renderFileTypeCard(archiveInfo)}

              {renderFileDetails(archiveInfo)}

              {renderDownloadButton(archiveInfo)}
            </div>
          )
      )}
    </div>
  );
};

export default FileDownload;
